import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
// import * as uuid from 'uuid';
import { v4 as uuidv4 } from 'uuid';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SuppInvPaymentMethodComponent } from '../supp-inv-payment-method/supp-inv-payment-method.component';
import { TransportFeeComponent } from '../transport-fee/transport-fee.component';
import { TranslateService } from '@ngx-translate/core';
// import { element } from 'protractor';
import { StoreSelectComponent } from '../store-select/store-select.component';

// import { SearchCustomerComponent } from '../search-customer/search-customer.component';
// import { KeyboardComponent } from '../keyboard/keyboard.component';
// import { InvoiceItemComponent } from '../invoice-item/invoice-item.component'; 
import {InvoiceItemComponent} from '../invoice-item/invoice-item.component';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {

  public menu_id = '1';
  public menu_item_id = '11';
  public return_menu_item_id = '22';
  public add_auth;
  title = '';

  // search_Bank = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'searchField',
  //   'table_list': [{
  //     'table_name': '`bank_account`', 'selected_no': 'acct_number',
  //     'field_list': ['acct_number', 'bank_acct_number', 'account_name', 'account_name_en']
  //   }]
  // };

  model = {
    'table_name': 'invoice', 'invoice_id': '0', 'invoice_no': '', 'invoice_date': '0000-00-00', 'customer_no': '',
    'customer_name': '', 'calc_tax': '1', 'print_tax': '1', 'total': '', 'tax': '', 'discount': '', 'rep_emp_no': '0',
    'deliver_date': '0000-00-00', 'payment_date': '0000-00-00', 'invoice_type': 'stock', 'cond_list_id': '0',
    'transport_fee': '0', 'received_by': '', 'is_paid': '1', 'status': '1', 'cost_center': '0',
    'sales_acct': '0', 'acct_number': '0', 'flag': '', 'key': 'invoice_id', 'qutation_no': '',
    'tax_acct': '0', 'trans_acct': '0', 'payment_method': '', 'comment': '', 'meter_reading': '', 
    'worker': '', 'delivery_no': '', 'advanced_amount': '0', 'prev_invoices_total': '0', 'rem_balance': '0',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id,
    'store_id': this.applicationConstants.user_branch_info.user_store_id, 'no': '0', 'year': '', 
    'discount_perc': '', 'retention_perc': '', 'retention_amount': '0', 'invoice_uuid': ''
  };

  data_model = {
    'type': '', 'invoiceDate': new Date(), 'final_total': '', 'paid_amount': '', 'rem_amount': '', 
    'bank_acct_number': '0', 'deliverDate': new Date(), 'paymentDate': new Date(), 'inv_discount': '', 
    'item_discount': '', 'final_discount': '', 'comment': '', 'old_final_total': 0, 'has_cash_receipt': 0, 
    'is_cc': '0', 'qutation_date': '', 'qutation_total': '', 'advanced_perc': '0', 'invoices_count': '0', 
    'invoices_total': '0', 'first_balance': '0', 'total_w_advanced': '0', 'has_retention': '0'
  };

  search_obj = {
    'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'condition': " AND (`branch_id` = '" + this.model['branch_id'] + "' OR `branch_id` = '0')"
    }]
  };

  search_cc = {
    'placeholder': 'مركز التكلفة (الرئيسي)', 'class_name': 'smallSearchField',
    'table_list': [{
      'table_name': '`cost_center`', 'selected_no': 'cc_id',
      'field_list': ['cc_name', 'cc_name_en']
    }]
  };

  // , 'has_customer':'0'
  // searchDialogRef: MatDialogRef<SearchCustomerComponent>;
  payDialogRef: MatDialogRef<SuppInvPaymentMethodComponent>;

  // customer_name;
  // mobile;

  public dp = [];
  private dp1 = [];
  
  displayedColumns1 = ['payment_type_name', 'amount'];
  feeDialogRef: MatDialogRef<TransportFeeComponent>;
  storeDialogRef: MatDialogRef<StoreSelectComponent>;
  dataSource1 = new MatTableDataSource(this.dp1);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(InvoiceItemComponent) invoice_list_comp:InvoiceItemComponent;
  // unitList = [];
  // customerList = [];
  bankAcctList = [];
  transAcctList = [];
  cost_centers = [];
  invCondList = [];
  repEmpList = [];
  print_type;
  thermal_print_type;
  payment_list = [];
  // bankList = [];

  // for update 
  type = '';
  mode;
  no;
  invoice_detail = {};
  inv_payment_method = [];
  count = 0;
  invoice_item = [];
  stock_list = {};
  // qty_list = {};

  public toDelete = [];
  // is_debit = false;
  all_payment_types = [];
  payment_method = '';
  store_name = '';
  customerDetail = '';
  bankDetail = '';
  transDetail = '';
  saveClicked = false;

  @HostListener('window:keydown', ['$event'])
  handleKeyDownEvent(event: KeyboardEvent) {
  
    if (event.key == "F4")
      this.addPayment();

    if (event.key == "F7")
      this.saveInvoice('print');

    if (event.key == "F8")
      this.saveInvoice('save_only');

    if (event.ctrlKey && (event.key == 'b' || event.key == 'B'))
      this.transport_fee();

    if (event.ctrlKey && (event.key == 'm' || event.key == 'M')) {
      let paidAmountField = document.getElementById('paid_amount') as HTMLInputElement;
      paidAmountField.focus();
      paidAmountField.select();
    }

  }

  Invoice; Customer_Placeholder; Repair_Invoice; Return_Invoice; One_Item_Msg;
  Customer_Msg; Pay_Msg; Bank_Acct_Msg; Rep_Msg; Inv_No_Msg; Acct_Placeholder;
  Success_Msg; Error_Msg; Not_Counter_Msg; Customer_Cc_Msg; Installment_Invoice;
  Cant_Add_Msg1; Cant_Add_Msg2; Ret_Amount; PO_Balance; Advanced_Invoice;
  Meter_Reading; Worker; PO_No; Ship_To; CC_Placeholder;
  field_title1; field_title2; field_title3;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private route: ActivatedRoute, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Invoice').subscribe((res: string) => {
      this.Invoice = res;
    });
    // this.title = this.Invoice;

    // translate.get('Acct_Placeholder').subscribe((res: string) => {
    //   this.Acct_Placeholder = res;
    // });
    // this.search_Bank['placeholder'] = this.Acct_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Customer_Placeholder').subscribe((res: string) => {
      this.Customer_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Customer_Placeholder;

    translate.get('CC_Placeholder').subscribe((res: string) => {
      this.CC_Placeholder = res;
    });
    this.search_cc['placeholder'] = this.CC_Placeholder;

    translate.get('Repair_Invoice').subscribe((res: string) => {
      this.Repair_Invoice = res;
    });

    translate.get('Return_Invoice').subscribe((res: string) => {
      this.Return_Invoice = res;
    });
    
    translate.get('Advanced_Invoice').subscribe((res: string) => {
      this.Advanced_Invoice = res;
    });

    translate.get('Installment_Invoice').subscribe((res: string) => {
      this.Installment_Invoice = res;
    });

    translate.get('One_Item_Msg').subscribe((res: string) => {
      this.One_Item_Msg = res;
    });

    translate.get('Customer_Msg').subscribe((res: string) => {
      this.Customer_Msg = res;
    });

    translate.get('Pay_Msg').subscribe((res: string) => {
      this.Pay_Msg = res;
    });

    translate.get('Bank_Acct_Msg').subscribe((res: string) => {
      this.Bank_Acct_Msg = res;
    });

    translate.get('Not_Counter_Msg').subscribe((res: string) => {
      this.Not_Counter_Msg = res;
    });

    translate.get('Rep_Msg').subscribe((res: string) => {
      this.Rep_Msg = res;
    });

    translate.get('Inv_No_Msg').subscribe((res: string) => {
      this.Inv_No_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Customer_Cc_Msg').subscribe((res: string) => {
      this.Customer_Cc_Msg = res;
    });

    translate.get('Cant_Add_Msg1').subscribe((res: string) => {
      this.Cant_Add_Msg1 = res;
    });

    translate.get('Cant_Add_Msg2').subscribe((res: string) => {
      this.Cant_Add_Msg2 = res;
    });

    translate.get('Meter_Reading').subscribe((res: string) => {
      this.Meter_Reading = res;
    });

    translate.get('Worker').subscribe((res: string) => {
      this.Worker = res;
    });
    
    translate.get('PO_No').subscribe((res: string) => {
      this.PO_No = res;
    });

    translate.get('Ship_To').subscribe((res: string) => {
      this.Ship_To = res;
    });

    translate.get('Ret_Amount').subscribe((res: string) => {
      this.Ret_Amount = res;
    });

    translate.get('PO_Balance').subscribe((res: string) => {
      this.PO_Balance = res;
    });
  }

  ngOnInit() {

    if (this.utils.getParamValue('default_invoice_status') != 'NPV')
      this.model['status'] = this.utils.getParamValue('default_invoice_status');
      
    if (this.utils.getParamValue('has_retention') != 'NPV')
      this.data_model['has_retention'] = this.utils.getParamValue('has_retention');

    (document.getElementById('status') as HTMLInputElement).checked = (this.model['status'] == '1');

    let href = this.router.url;
    let urlParts = href.split("/");
    this.menu_id = urlParts[2];
    
    if (this.menu_id == '1') {
      this.menu_item_id = '11';
      this.title = this.Invoice;
      this.field_title1 = this.PO_No;
      this.field_title2 = this.Ship_To;
    }
    else if (this.menu_id == '12') {
      this.menu_item_id = '82';
      this.title = this.Repair_Invoice;
      this.field_title1 = this.Meter_Reading;
      this.field_title2 = this.Worker;
    }
    this.field_title3 = this.Ret_Amount;

    let query, obj, selObj;

    // get leaf bank accts
    let parent_acct = this.applicationConstants.main_acct_config['bank'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.bankAcctList = data.data['list'];
      });

    // get leaf transport income accts
    parent_acct = this.applicationConstants.main_acct_config['transport_income'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.transAcctList = data.data['list'];
      });

    // Added by Hassan 11-27-2019 [START]
    // ******************* Get All Payment Types to send array to supp_inv_payment_method component ******************* //
    query = this.queryList.all_paymentType;
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_payment_types = data.data['list'];
        if (this.all_payment_types.length == 5)
          this.all_payment_types.splice(4, 1);

        console.log(this.all_payment_types);
      });
    // END 

    this.model['calc_tax'] = this.utils.getParamValue('cal_tax');
    
    this.print_type = this.utils.getParamValue('print_type');
    let different_branch = this.utils.getParamValue('different_branch');
    if (different_branch == '1') {
      query = this.queryList.all_branch + " AND `branch_id` = '" + 
        this.applicationConstants.user_branch_info.user_branch_id + "'";

      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
  
          if (data.data['list'].length > 0)
            this.print_type = data.data['list'][0]['print_type'];

          let condition = (this.print_type == 'normal' ? "`invoice_type_key` = 'normal_invoice'" : "`invoice_type_key` = 'thermal_invoice'");

          query = "SELECT `cond_list_id` FROM `def_inv_cond_list` WHERE `branch_id` = '" + 
            this.model['branch_id'] + "' AND " + condition;
          obj = { cmd: 'getList', query: query };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
      
              if (data.data['list'].length > 0)
                this.model['cond_list_id'] = data.data['list'][0]['cond_list_id'];
            });
        });
    }
    else {
      let condition = (this.print_type == 'normal' ? "`invoice_type_key` = 'normal_invoice'" : "`invoice_type_key` = 'thermal_invoice'");

      query = "SELECT `cond_list_id` FROM `def_inv_cond_list` WHERE `branch_id` = '" + 
        this.model['branch_id'] + "' AND " + condition;
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
  
          if (data.data['list'].length > 0)
            this.model['cond_list_id'] = data.data['list'][0]['cond_list_id'];
        });
    }
    this.thermal_print_type = this.utils.getParamValue('thermal_print_type');
    
    query = this.queryList.all_costCenter;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cost_centers = data.data['list'];

        let costObj = { 'cc_id': '0', 'cc_number': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'Main' };
        this.cost_centers.unshift(costObj);
      });

    let default_payment_type = this.utils.getParamValue('default_payment_type');
    if (default_payment_type != undefined || default_payment_type != '') {
      query = "SELECT * FROM `payment_type` WHERE `status` = '1' AND `payment_type_key` = '" +
        default_payment_type + "'";
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.payment_list = data.data['list'];
        });
    }

    query = this.queryList.all_invCondList + " AND (`branch_id` = '0' OR `branch_id` = '" + 
      this.applicationConstants.user_branch_info.user_branch_id + "')";
    obj = { cmd: 'getList', query: query };
    
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.invCondList = data.data['list'];

        selObj = { 'cond_list_id': '0', 'list_name': 'اختر', 'list_name_en': 'Select' };
        this.invCondList.unshift(selObj);
      });

    query = this.queryList.all_repEmp;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.repEmpList = data.data['list'];

        selObj = { 'employee_id': '0', 'employee_no': '0', 'name': 'اختر', 'name_en': 'Select' };
        this.repEmpList.unshift(selObj);
      });

    this.route.params.subscribe(params => {
      
      if (params['type'] != undefined) {

        this.type = params['type'];
        this.data_model['type'] = this.type;
        this.mode = params['mode'];
        this.no = params['no'];

        if (this.type == 'invoice') {
          if (this.mode != 'export_qutation') {
            query = "SELECT `invoice`.* FROM `invoice` WHERE `invoice`.`invoice_no` = '" + this.no + "'";
            obj = { cmd: 'getList', query: query };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                this.invoice_detail = data.data['list'][0];
               
                if (this.mode == 'edit') {
                  this.model['invoice_id'] = this.invoice_detail['invoice_id'];
                  this.model['invoice_no'] = this.invoice_detail['invoice_no'];
                  this.model['no'] = this.invoice_detail['no'];
                  this.model['year'] = this.invoice_detail['year'];

                  // check if there is cash receipt for this invoice
                  query = "SELECT `cash_receipt`.`cash_receipt_no`, `cash_receipt`.`paid` FROM " +
                    "`cash_receipt`, `cash_receipt_invoice` WHERE `cash_receipt_invoice`.`invoice_no` = '" +
                    this.no + "' AND `cash_receipt_invoice`.`status` != '0' AND " +
                    "`cash_receipt_invoice`.`cash_receipt_no` = `cash_receipt`.`cash_receipt_no`";

                  obj = { cmd: 'getList', query: query };

                  this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                    .subscribe(data => {
                      this.applicationConstants.appComp.hideBusyCursor();
                      this.data_model['has_cash_receipt'] = (data.data['list'].length > 0 ? 1 : 0);
                    });
                }

                this.model['invoice_date'] = this.invoice_detail['invoice_date'];
                this.data_model['invoiceDate'] = new Date(this.invoice_detail['invoice_date']);

                this.model['customer_no'] = this.invoice_detail['customer_no'];
                this.model['customer_name'] = this.invoice_detail['customer_name'];

                if (this.invoice_detail['customer_no'] == '')
                  this.customerDetail = this.model['customer_name'];
                else {
                  query = "SELECT * FROM `customer` WHERE `acct_number` = '" + this.invoice_detail['customer_no'] + "'";
                  obj = { cmd: 'getList', query: query };

                  this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                    .subscribe(data => {
                      this.applicationConstants.appComp.hideBusyCursor();

                      let custDetail = data.data['list'][0];
                      this.customerDetail = custDetail['acct_number'] + "-" + custDetail['customer_name'] +
                        "-" + custDetail['customer_name_en'] + "-" + custDetail['mobile'];

                      this.data_model['is_cc'] = custDetail['is_account'];
                    });
                }
                this.model['comment'] = this.invoice_detail['comment'];
                this.model['total'] = this.invoice_detail['total'];
                this.model['discount'] = this.invoice_detail['discount'];
                this.model['tax'] = this.invoice_detail['tax'];
                this.model['transport_fee'] = this.invoice_detail['transport_fee'];

                this.data_model['final_total'] = (Number(this.invoice_detail['total']) -
                  Number(this.invoice_detail['discount']) + Number(this.invoice_detail['tax']) + 
                  Number(this.invoice_detail['transport_fee'])).toFixed(2);

                this.data_model['old_final_total'] = Number(this.data_model['final_total']);

                this.model['rep_emp_no'] = this.invoice_detail['rep_emp_no'];
                this.model['deliver_date'] = this.invoice_detail['deliver_date'];
                this.data_model['deliverDate'] = new Date(this.invoice_detail['deliver_date']);
                this.model['payment_date'] = this.invoice_detail['payment_date'];
                this.data_model['paymentDate'] = new Date(this.invoice_detail['payment_date']);
                this.model['cond_list_id'] = this.invoice_detail['cond_list_id'];
                
                this.model['received_by'] = this.invoice_detail['received_by'];
                this.model['is_paid'] = this.invoice_detail['is_paid'];
                this.model['status'] = this.invoice_detail['status'];
                this.model['cost_center'] = this.invoice_detail['cost_center'];
                this.model['branch_id'] = this.invoice_detail['branch_id'];
                this.model['store_id'] = this.invoice_detail['store_id'];

                query = "SELECT `store`.* FROM `store` WHERE `store`.`store_id` = '" + this.model['store_id'] + "'";
                obj = { cmd: 'getList', query: query };
                this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                  .subscribe(data => {
                    this.applicationConstants.appComp.hideBusyCursor();
                    let storeDetail = data.data['list'][0];
                    this.store_name = storeDetail['store_name'];
                  });

                (document.getElementById('status') as HTMLInputElement).checked = (this.model['status'] == '1');

                if (this.invoice_detail['cost_center'] != '0') {
                  query = "SELECT * FROM `cost_center` WHERE `cc_id` = '" + this.invoice_detail['cost_center'] + "'";
                  obj = { cmd: 'getList', query: query };

                  this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                    .subscribe(data => {
                      this.applicationConstants.appComp.hideBusyCursor();
                      let costCenter = data.data['list'][0];
                      (document.getElementById('search_value_1') as HTMLInputElement).value = costCenter['cc_name'] +
                        (costCenter['cc_name_en'] != '' ? "-" + costCenter['cc_name_en'] : '');
                    });
                }

                this.model['sales_acct'] = this.invoice_detail['sales_acct'];
                this.model['acct_number'] = this.invoice_detail['acct_number'];
                // this.model['bank_acct_number'] = this.invoice_detail['bank_acct_number'];
                this.model['tax_acct'] = this.invoice_detail['tax_acct'];
                this.model['trans_acct'] = this.invoice_detail['trans_acct'];
                this.model['flag'] = 'update';
                this.model['meter_reading'] = this.invoice_detail['meter_reading'];
                this.model['worker'] = this.invoice_detail['worker'];
                this.model['delivery_no'] = this.invoice_detail['delivery_no'];

                if (this.mode == 'copy') {
                  this.model['invoice_id'] = '0';
                  this.model['invoice_no'] = '';
                  this.data_model['invoiceDate'] = new Date();
                  this.model['flag'] = 'new';
                }

                this.getInvoiceItems();
                this.getPaymentMethod();
              });
          }
          if (this.mode == 'export_qutation') 
            this.exportQutation(this.no);

        }
        else if (this.type == 'return_invoice') {
          this.title = this.Return_Invoice;
          this.model['table_name'] = 'return_invoice';

          if (this.mode == 'edit')
            this.getRetInvoice();
        }

      }

      if (params['type'] == undefined || (this.type == 'return_invoice' && this.mode == undefined) || 
        this.mode == 'export_qutation' || this.mode == 'copy') {

        // check add authorization
        if (this.type == 'return_invoice' && this.mode == undefined)
          this.add_auth = this.utils.getAuth(this.return_menu_item_id, this.applicationConstants.ADD_AUTH); 
        else
          this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
          

        let user_id = this.applicationConstants.user_info['user_id'];
        //get store list:
        let query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
          " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
          " `branch_auth`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id +
          "' AND `branch_auth`.`user_id` = '" + user_id + "' AND `branch_auth`.`store_id` = `store`.`store_id`";

        let obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let store_list = [];
            store_list = data.data['list'];

            if (store_list.length > 1) {
              let dialog_data = store_list;
              this.storeDialogRef = this.dialog.open(StoreSelectComponent, {
                hasBackdrop: false,
                data: dialog_data
              });
              this.storeDialogRef
                .afterClosed()
                .subscribe(result => {
                  if (result != null && result['op_type'] == 'success')
                    this.store_name = (this.applicationConstants.user_lang == 'ar' ? this.applicationConstants.user_branch_info.user_store_name : this.applicationConstants.user_branch_info.user_store_name_en);
                });
            }
            else {
              this.applicationConstants.user_branch_info.user_store_id = store_list['0']['store_id'];
              this.applicationConstants.user_branch_info.user_store_name = (this.applicationConstants.user_lang == 'ar' ? store_list['0']['store_name'] : store_list['0']['store_name_en']);
              this.store_name = (this.applicationConstants.user_lang == 'ar' ? this.applicationConstants.user_branch_info.user_store_name : this.applicationConstants.user_branch_info.user_store_name_en);
            }

          });
      }
      else
        this.add_auth = true;
    });


    // if (this.route.snapshot.paramMap.get("type") != null) {
    //   if (this.route.snapshot.paramMap.get("type") == "return_invoice")
    //     this.title = this.Return_Invoice;

    // }
  }

  // header discount is added
  onChangeHeaderDiscount(){
    //console.log(`Header Discount: ${this.model.discount_perc}`);
    this.invoice_list_comp._updateHeaderDiscount(this.model.discount_perc);
  }

  changeStatus() {
    this.model['status'] = ((document.getElementById('status') as HTMLInputElement).checked ? '1' : '2');
  }

  // onChangeCustomer = function (acct_number: string) {
  //   console.log(acct_number);

  //   this.model['customer_no'] = acct_number;
  //   this.model['customer_name'] = (document.getElementById('search_value_0') as HTMLInputElement).value;

  //   if (this.model['customer_no'] != '') {
  //     this.applicationConstants.customerList.forEach(element => {
  //       if (element.acct_number == this.model['customer_no']) {
  //         this.data_model['is_cc'] = element.is_cc;
  //         return;
  //       }
  //     });
  //   }

  //   // ******************* In Edit Mode change flag for default payment method to update ******************* //
  //   if (this.mode != undefined && this.mode == 'edit') {

  //     this.dp1.forEach(element => {
  //       if (element.payment_type_key == 'credit') {

  //         this.all_payment_types.forEach(element1 => {
  //           if (element1.payment_type_key == element.payment_type_key) {
  //             if (element1.inv_payment_method_id != '')
  //               element1.flag = 'update';
  //             return false;
  //           }
  //         });

  //         return false;
  //       }
  //     });
  //   }
  // }

  onChangeSearch = function (search_result: object) {
    console.log('result');
    console.log(search_result);
    // this.model['rep_emp_no'] = '0';
    this.model['customer_name'] = search_result['value'];
    this.model['customer_no'] = search_result['no'];

    if (search_result['no'] != "") {
      this.model['customer_name'] = (document.getElementById('search_value_0') as HTMLInputElement).value;
      
      let query = "SELECT * FROM `customer` WHERE `acct_number` = '" + search_result['no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let customer = data.data['list'];

          if (customer.length > 0) 
            this.data_model['is_cc'] = customer['0']['is_account'];
        });
    }
    else 
      this.data_model['is_cc'] = '0'; 

    console.log(this.model['customer_name']);
    // ******************* In Edit Mode change flag for default payment method to update ******************* //
    if (this.mode != undefined && this.mode == 'edit') {

      this.dp1.forEach(element => {
        if (element.payment_type_key == 'credit') {

          this.all_payment_types.forEach(element1 => {
            if (element1.payment_type_key == element.payment_type_key) {
              if (element1.inv_payment_method_id != '')
                element1.flag = 'update';
              return false;
            }
          });

          return false;
        }
      });
    }
  }

  // searchCustomer() {
  //   let event = new KeyboardEvent('keydown', {key: "Enter"}); 
  //   (document.getElementById('search_value_0') as HTMLInputElement).dispatchEvent(event);
  // }

  onChangeCcSearch = function (search_result: object) {
    console.log(search_result['no']);
    if (search_result['no'] != '')
      this.model['cost_center'] = search_result['no'];
    else
      this.model['cost_center'] = '0';
    console.log(this.model['cost_center']);
  }

  getPaymentMethod() {

    /////////////////////////// get invoice payment method ///////////////////////////
    let table_name = (this.type == 'invoice' ? 'inv_payment_method' : 'ret_inv_payment_method');
    let key = (this.type == 'invoice' ? 'inv_payment_method_id' : 'ret_inv_payment_method_id');
    let field_no = this.type + "_no";

    let query = "SELECT `" + table_name + "`.*, `payment_type`.*, 'update' AS 'flag', '" + key + "' AS 'key' FROM `"
      + table_name + "`, `payment_type` WHERE `" +
      table_name + "`.`" + field_no + "` = '" + this.no + "' AND `" + table_name +
      "`.`payment_type_id` = `payment_type`.`payment_type_id` AND `" + table_name + "`.`status` != '0'";
    let obj = { cmd: 'getList', query: query };
    // console.log(query);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        // this.inv_payment_method = data.data['list'];
        this.dp1 = data.data['list'];
        console.log('this.dp1');
        console.log(this.dp1);

        let index;
        this.dp1.forEach(element => {
          if (element.payment_type_key == 'credit') {
            document.getElementById('td_payment_date').style.display = 'inline';
            document.getElementById('td_payment_date2').style.display = 'inline';
          }
          else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa') {
            document.getElementById('td_bank_acct').style.display = 'inline';
            document.getElementById('td_bank_acct2').style.display = 'inline';

            this.data_model['bank_acct_number'] = element.acct_number;
            let query1 = "SELECT * FROM `bank_account` WHERE `acct_number` = '" + element.acct_number + "'";
            obj = { cmd: 'getList', query: query1 };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let acct_info = data.data['list'][0];
                this.bankDetail = acct_info.bank_acct_number + ' - ' + acct_info.acct_number + ' - ' +
                  acct_info.account_name + ' - ' + acct_info.account_name_en;

                // (document.getElementById('search_value_2') as HTMLInputElement).value = acct_info.bank_acct_number + ' - ' + acct_info.acct_number + ' - ' + acct_info.account_name + ' - ' + acct_info.account_name_en;

              });
          }

          // ******************* Based on the invoice payment method fill amount, inv_payment_method_id and falg in All Payment Types array ******************* //
          this.all_payment_types.forEach(element1 => {

            if (element1.payment_type_id == element.payment_type_id) {
              element1.amount = element.amount;
              element1.inv_payment_method_id = (this.type == 'invoice' ? element.inv_payment_method_id : element.ret_inv_payment_method_id);
            }
            else if (element1.flag == undefined) {
              element1.amount = '';
              element1.inv_payment_method_id = '';
            }
            element1.flag = '';

            if (this.mode == 'copy' && element1.payment_type_id == element.payment_type_id)
              element1.flag = 'new';
          });
        });
        console.log('this.all_payment_types');
        console.log(this.all_payment_types);


        // this.dp1.push({
        //   'payment_type_id': '0', 'payment_type_key': 'total', 'payment_type_name': 'المجموع المدخل',
        //   'payment_type_name_en': 'Total', 'amount': this.data_model['final_total'], 'flag':'update', 
        //   'key':'inv_payment_method_id'
        // });
        this.dataSource1 = new MatTableDataSource(this.dp1);
        this.dataSource1.sort = this.sort;

        if (this.dp1.length == 1)
          this.payment_method = (this.applicationConstants.user_lang == 'ar' ? this.dp1[0]['payment_type_name'] : this.dp1[0]['payment_type_name_en']);
        else
          this.payment_method = (this.applicationConstants.user_lang == 'ar' ? 'متعدد' : 'Multiple');
      });
  }

  getInvoiceItems() {

    let obj = {
      cmd: 'getInvoiceItem', type: (this.mode == 'export_qutation' ? 'qutation' : this.type),
      invoice_no: this.no
    };

    if (this.mode == 'export_qutation')
      obj['for_export'] = '1';
    
    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.invoice_item = []; // data.data['list'];
        if (data.status['type'] == 'success')
          this.invoice_item = data.status['msg'];

        if (this.mode == 'export_qutation') {
          let alertMsg = '';
          let total_qty = 0;

          this.invoice_item.forEach(element => {
            total_qty = 0;
            
            if (this.model.invoice_type == 'advanced' || this.model.invoice_type == 'install') 
              element.install_perc = '0';

            this.dp.forEach(element1 => {
              if (element.sub_item_no == element1.sub_item_no)
                total_qty += Number(element1.count);
            });
            total_qty += Number(element.count);
  
            if (element.stock_link == '0' || 
              (this.model.invoice_type == 'advanced' || this.model['invoice_type'] == 'install' && Number(this.data_model['invoices_count']) > 0) || 
              (element.stock_link == '1' && total_qty <= Number(element.available_count))) {
              if (this.stock_list[element.sub_item_no] == undefined)
                this.stock_list[element.sub_item_no] = element.available_stock;
  
              this.dp.push(element);
            }
            else {
              if (alertMsg != "")
                alertMsg += " - "
              alertMsg += element.sub_item_name;
            }
          });
  
          if (alertMsg != "") 
            alert(this.Cant_Add_Msg1 + " (" + alertMsg + ") " + this.Cant_Add_Msg2);
        }
        else 
          this.dp = this.invoice_item;

      });
  }


  // ******************* Exoprt Qutation to Invoice ******************* //

  exportQutation(no) {
    //get qutation detail:
    let query = "SELECT * FROM `qutation` WHERE `qutation_no` = '" + no + "'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let qutation = data.data['list'];

        this.model['customer_no'] = qutation[0]['customer_no'];
        this.model['customer_name'] = qutation[0]['customer_name'];

        if (qutation[0]['for_install_invoice'] != '0') {
          
          this.field_title3 = this.PO_Balance;
          let total_inv = 0, invoices_count = 0;
          
          this.data_model['advanced_perc'] = qutation[0]['advanced_perc'];
          this.data_model['qutation_date'] = (qutation[0]['qutation_date']).substring(0, 10);
          this.data_model['qutation_total'] = (Number(qutation[0]['total']) - Number(qutation[0]['discount'])).toFixed(2);

          // get the count and sum of previous invoices
          if (qutation[0]['for_install_invoice'] == '1') {

            query = "SELECT `total`, `advanced_amount` FROM `invoice` WHERE " + 
              "`invoice_type` = 'advanced' AND `qutation_no` = '" + qutation[0]['qutation_no'] + 
              "' AND `meter_reading` = '" + qutation[0]['po_no'] + "' AND `status` != '0' AND `status` != '3'";

            obj = { cmd: 'getList', query: query };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                let result = data.data['list'];

                if (result.length == 0 && Number(qutation[0]['advanced_perc']) > 0) {

                  this.title = this.Advanced_Invoice;
                  this.model['invoice_type'] = 'advanced';
                  this.model['advanced_amount'] = (Number(this.data_model['qutation_total']) * (Number(this.data_model['advanced_perc'])/ 100)).toFixed(2);

                  this.data_model['invoices_count'] = invoices_count.toString();
                  this.model['prev_invoices_total'] = total_inv.toFixed(2);
                  this.data_model['first_balance'] = (Number(this.data_model['qutation_total']) - total_inv).toFixed(2);
                }
                else {
                  total_inv = (result.length > 0 ? Number(result[0]['advanced_amount']) : 0);
                  invoices_count = 1;
                  this.title = this.Installment_Invoice;
                  this.model['invoice_type'] = 'install';

                  query = "SELECT COALESCE(COUNT(`invoice_id`), 0) AS `incoice_count`, COALESCE(SUM(`total`), 0) AS " + 
                    "`total`, COALESCE(SUM(`advanced_amount`), 0) AS `advanced_amount` FROM `invoice` WHERE " + 
                    "`invoice_type` = 'install' AND `qutation_no` = '" + 
                    qutation[0]['qutation_no'] + "' AND `meter_reading` = '" + qutation[0]['po_no'] + 
                    "' AND `status` != '0' AND `status` != '3'";
  
                  obj = { cmd: 'getList', query: query };
                  this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                    .subscribe(data => {
                      this.applicationConstants.appComp.hideBusyCursor();

                      result = data.data['list'];
                      total_inv += (Number(result[0]['total']) - Number(result[0]['advanced_amount']));
                      invoices_count += Number(result[0]['incoice_count']);
                      
                      this.data_model['invoices_count'] = invoices_count.toString();
                      this.model['prev_invoices_total'] = total_inv.toFixed(2);
                      this.data_model['first_balance'] = (Number(this.data_model['qutation_total']) - total_inv).toFixed(2);
                    });
                }
                console.log(this.model['invoice_type']);
              });
          }
          else {
            total_inv = 0;
            invoices_count = 1;
            this.title = this.Installment_Invoice;
            this.model['invoice_type'] = 'qty_install';

            query = "SELECT COALESCE(COUNT(`invoice_id`), 0) AS `incoice_count`, COALESCE(SUM(`total`), 0) AS " + 
              "`total`, COALESCE(SUM(`advanced_amount`), 0) AS `advanced_amount` FROM `invoice` WHERE " + 
              "`invoice_type` = 'qty_install' AND `qutation_no` = '" + qutation[0]['qutation_no'] + "' AND `meter_reading` = '" + qutation[0]['po_no'] + 
              "' AND `status` != '0' AND `status` != '3'";

            obj = { cmd: 'getList', query: query };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let result = data.data['list'];
                total_inv += (Number(result[0]['total']) - Number(result[0]['advanced_amount']));
                invoices_count += Number(result[0]['incoice_count']);
                
                this.data_model['invoices_count'] = invoices_count.toString();
                this.model['prev_invoices_total'] = total_inv.toFixed(2);
                this.data_model['first_balance'] = (Number(this.data_model['qutation_total']) - total_inv).toFixed(2);

                console.log(this.model['invoice_type']);
              });
          }
        }

        //get customer detail:
        if (qutation['0']['customer_no'] != '' && qutation['0']['customer_no'] != '0') {

          let query = "SELECT * FROM `customer` WHERE `acct_number` = '" + qutation['0']['customer_no'] + "'";
          let obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              let customer = data.data['list'];

              if (customer.length > 0) {
                this.customerDetail = customer['0']['acct_number'] + "-" + customer['0']['customer_name'] +
                  "-" + customer['0']['customer_name_en'] + "-" + customer['0']['mobile'];

                // (document.getElementById('search_value_0') as HTMLInputElement).value = customer['0']['acct_number'] +
                //   "-" + customer['0']['customer_name'] + "-" + customer['0']['customer_name_en'] + "-" + customer['0']['mobile'];
                (document.getElementById('search_value_0') as HTMLInputElement).disabled = true;
                this.model['customer_no'] = customer['0']['acct_number'];
                this.model['customer_name'] = customer['0']['customer_name'];
                this.data_model['is_cc'] = customer['0']['is_account'];
              }
            });
        }
        else 
          this.customerDetail = this.model['customer_name'];

        //fill the field:
        this.model['meter_reading'] = qutation[0]['po_no'];
        this.model['total'] = qutation[0]['total'];
        this.model['discount'] = qutation[0]['discount'];
        this.model['tax'] = qutation[0]['tax'];
        this.model['comment'] = (qutation[0]['comment'] == null ? '' : qutation[0]['comment']);
        this.model['rep_emp_no'] = (qutation[0]['rep_id'] == null ? '0' : qutation[0]['rep_id']);
        this.model['cond_list_id'] = qutation[0]['cond_list_id'];
        this.model['flag'] = 'new';
        this.model['is_paid'] = '0';
        this.model['qutation_no'] = qutation[0]['qutation_no'];
        this.data_model['final_total'] = (Number(this.model['total']) + Number(this.model['tax']) - Number(this.model['discount'])).toFixed(2);
        this.data_model['final_discount'] = this.model['discount'];
        console.log('final_total: ' + this.data_model['final_total']);

        //fill invoice item table:
        // query = "SELECT `qutation_item`.*, `unit`.`unit_name`, `sub_item`.`sub_item_no` FROM `qutation_item`, `unit`," +
        //   " `sub_item` WHERE `qutation_item`.`qutation_no` = '" + no + "' AND `qutation_item`.`status` = '1'" +
        //   " AND `qutation_item`.`unit_id` = `unit`.`unit_id` AND `qutation_item`.`sub_item_number` = `sub_item`.`sub_item_number`";
        // obj = { cmd: 'getList', query: query };

        // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        //   .subscribe(data => {
        //     this.applicationConstants.appComp.hideBusyCursor();
        //     this.invoice_item = data.data['list'];
        //     this.invoice_item.forEach(element => {
        //       element.net_price = (Number(element.total_price) + Number(element.tax_amount) - Number(element.discount)).toFixed(2);
        //     });
        //     this.dp = this.invoice_item;
        //     //console.log(this.dp);

        //   });


        //get all qutation items:
        this.getInvoiceItems();

        //payment method:
        this.dp1 = this.payment_list;
        this.dp1[0]['amount'] = this.data_model['final_total'];
        this.payment_method = (this.applicationConstants.user_lang == 'ar' ? this.dp1[0]['payment_type_name'] : this.dp1[0]['payment_type_name_en']);

        // console.log('this.dp1');
        // console.log(this.dp1);
        this.all_payment_types.forEach(element1 => {
          if (element1.payment_type_id == this.dp1[0]['payment_type_id']) {
            element1.amount = this.data_model['final_total'];
            console.log('element1.amount: ' + element1.amount);
            element1.flag = 'new';
          }
          else if (element1.flag == undefined || element1.flag == 'new') {
            element1.amount = '0';
            element1.flag = '';
          }

          element1.inv_payment_method_id = '';
        });

        // console.log('this.all_payment_types');
        // console.log(this.all_payment_types);

        this.model['is_paid'] = (this.dp1[0]['payment_type_key'] == 'credit' || this.dp1[0]['payment_type_key'] == 'tamara' || this.dp1[0]['payment_type_key'] == 'tabby' ? '0' : '1');

        document.getElementById('td_payment_date').style.display = (this.dp1[0]['payment_type_key'] == 'credit' || this.dp1[0]['payment_type_key'] == 'tamara' || this.dp1[0]['payment_type_key'] == 'tabby' ? 'inline' : 'none');
        document.getElementById('td_payment_date2').style.display = (this.dp1[0]['payment_type_key'] == 'credit' || this.dp1[0]['payment_type_key'] == 'tamara' || this.dp1[0]['payment_type_key'] == 'tabby' ? 'inline' : 'none');

        document.getElementById('td_bank_acct').style.display = (this.dp1[0]['payment_type_key'] == 'bank' || this.dp1[0]['payment_type_key'] == 'visa' ? 'inline' : 'none');
        document.getElementById('td_bank_acct2').style.display = (this.dp1[0]['payment_type_key'] == 'bank' || this.dp1[0]['payment_type_key'] == 'visa' ? 'inline' : 'none');


        // this.dp1 = [{
        //   'payment_type_id': '1', 'payment_type_key': 'cash', 'flag': 'new', 'key': 'inv_payment_method_id',
        //   'payment_type_name': 'نقدي', 'payment_type_name_en': 'cash', 'total_entered': this.data_model['final_total'],
        //   'inv_payment_method_id': '', 'amount': this.data_model['final_total']
        // }];
        // this.dataSource1 = new MatTableDataSource(this.dp1);
        // this.dataSource1.sort = this.sort;

        // if (this.dp1.length == 1)
        //   this.payment_method = (this.applicationConstants.user_lang == 'ar' ? this.dp1[0]['payment_type_name'] : this.dp1[0]['payment_type_name_en']);
        // else
        //   this.payment_method = (this.applicationConstants.user_lang == 'ar' ? 'متعدد' : 'Multiple');

        // this.all_payment_types.forEach(element1 => {

        //   if (element1.payment_type_key == 'credit') {
        //     element1.amount = this.data_model['final_total'];
        //     element1.inv_payment_method_id = '0';
        //     element1.flag = 'new';
        //   }
        //   else if (element1.flag == undefined) {
        //     element1.amount = '';
        //     element1.inv_payment_method_id = '';
        //     element1.flag = '';
        //   }
        // });
      });

  }

  getRetInvoice() {
    let query = "SELECT `return_invoice`.* FROM `return_invoice` WHERE `return_invoice`.`return_invoice_no` = '" +
      this.no + "' AND `status` != '0'";
    let obj = { cmd: 'getList', query: query };
    //console.log(query);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.invoice_detail = data.data['list'][0];
        console.log(this.invoice_detail);

        //get customer detail:
        if (this.invoice_detail['customer_no'] != '') {
          let query = "SELECT * FROM `customer` WHERE `acct_number` = '" + this.invoice_detail['customer_no'] + "'";
          let obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              let customer = data.data['list'];

              if (customer.length > 0) {
                this.customerDetail = customer['0']['acct_number'] + "-" + customer['0']['customer_name'] +
                  "-" + customer['0']['customer_name_en'] + "-" + customer['0']['mobile'];

                // (document.getElementById('search_value_0') as HTMLInputElement).value = customer['0']['acct_number'] +
                //   "-" + customer['0']['customer_name'] + "-" + customer['0']['customer_name_en'] + "-" + customer['0']['mobile'];
                (document.getElementById('search_value_0') as HTMLInputElement).disabled = true;
                this.model['customer_no'] = customer['0']['acct_number'];
                this.model['customer_name'] = customer['0']['customer_name'];
                this.data_model['is_cc'] = customer['0']['is_account'];
              }
            });
        }

        //get cost center:
        if (this.invoice_detail['cost_center'] != '0') {
          query = "SELECT `cc_name` FROM `cost_center` WHERE `cc_number` = '" + this.invoice_detail['cost_center'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              let ccDetail = data.data['list'][0];
              (document.getElementById('search_value_1') as HTMLInputElement).value = ccDetail['cc_name'];
            });
        }
        console.log(this.invoice_detail);
        //fill the field:
        this.model['no'] = this.invoice_detail['no'];
        this.model['year'] = this.invoice_detail['year'];
        this.model['total'] = this.invoice_detail['total'];
        this.model['tax'] = this.invoice_detail['tax'];
        this.model['discount'] = this.invoice_detail['discount'];
        this.model['is_paid'] = this.invoice_detail['is_paid'];
        this.model['comment'] = this.invoice_detail['comment'];
        // this.model['rep_emp_no'] = this.invoice_detail['rep_emp_no'];
        // this.model['cond_list_id'] = this.invoice_detail['cond_list_id'];
        this.model['flag'] = 'update';
        this.data_model['final_total'] = (Number(this.model['total']) + Number(this.model['tax']) -
          Number(this.model['discount'])).toFixed(2);
        this.data_model['final_discount'] = this.model['discount'];
        this.model['branch_id'] = this.invoice_detail['branch_id'];
        this.model['store_id'] = this.invoice_detail['store_id'];

        query = "SELECT `store`.* FROM `store` WHERE `store`.`store_id` = '" + this.model['store_id'] + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let storeDetail = data.data['list'][0];
            this.store_name = storeDetail['store_name'];
          });

        //get return invoice items:
        this.getInvoiceItems();
        
        //payment method:
        this.getPaymentMethod();
      });
  }

  changeFinalTotal() {
    if (Number(this.data_model['final_total']) > 0 && this.payment_list.length > 0) {
      // if (this.payment_list.length > 0) {
      let index;

      if (this.dp1.length == 0 || this.dp1.length > 1) {

        if (this.mode != undefined && this.mode == 'edit') {
          let existed = false;

          // ******************* in the edit mode, change the payment method to default and change the flag of saved payment method to delete and remove it from array ******************* //
          for (let indx = this.dp1.length - 1; indx >= 0; indx--) {
            existed = false;

            for (index = 0; index < this.payment_list.length; index++) {
              if (this.payment_list[index]['payment_type_id'] == this.dp1[indx]['payment_type_id']) {
                existed = true;
                break;
              }
            }

            if (!existed) {
              let flag = this.dp1[indx]['flag'];

              if (flag != 'new') {
                for (index = 0; index < this.all_payment_types.length; index++) {
                  if (this.all_payment_types[index]['payment_type_id'] == this.dp1[indx]['payment_type_id']) {
                    this.all_payment_types[index]['amount'] = this.dp1[indx]['amount'];
                    this.all_payment_types[index]['flag'] = 'delete';
                    this.all_payment_types[index]['inv_payment_method_id'] = this.dp1[indx]['inv_payment_method_id'];

                    break;
                  }
                }
              }

              this.dp1.splice(indx, 1);
            }
          }

          // ******************* in the edit mode, after changing the flag of saved payment method to delete and remove it from array. if array is empty, fill it with default payment ******************* //
          if (this.dp1.length == 0) {
            this.dp1 = this.payment_list;
            this.all_payment_types.forEach(element1 => {

              if (element1.payment_type_id == this.dp1[0]['payment_type_id']) {
                element1.amount = this.data_model['final_total'];
                if (element1.inv_payment_method_id != '')
                  element1.flag = 'update';
                else
                  element1.flag = 'new';

                return false;
              }
            });
          }
        }
        else {
          // ******************* in the new mode and after filling the array with default payment, change the flag to new ******************* //
          this.dp1 = this.payment_list;
          this.all_payment_types.forEach(element1 => {

            if (element1.payment_type_id == this.dp1[0]['payment_type_id']) {
              element1.amount = this.data_model['final_total'];
              element1.flag = 'new';
            }
            else if (element1.flag == undefined || element1.flag == 'new') {
              element1.amount = '';
              element1.flag = '';
            }

            element1.inv_payment_method_id = '';
          });
        }

        this.model['is_paid'] = (this.dp1[0]['payment_type_key'] == 'credit' || this.dp1[0]['payment_type_key'] == 'tamara' || this.dp1[0]['payment_type_key'] == 'tabby' ? '0' : '1');

        document.getElementById('td_payment_date').style.display = (this.dp1[0]['payment_type_key'] == 'credit' || this.dp1[0]['payment_type_key'] == 'tamara' || this.dp1[0]['payment_type_key'] == 'tabby' ? 'inline' : 'none');
        document.getElementById('td_payment_date2').style.display = (this.dp1[0]['payment_type_key'] == 'credit' || this.dp1[0]['payment_type_key'] == 'tamara' || this.dp1[0]['payment_type_key'] == 'tabby' ? 'inline' : 'none');

        document.getElementById('td_bank_acct').style.display = (this.dp1[0]['payment_type_key'] == 'bank' || this.dp1[0]['payment_type_key'] == 'visa' ? 'inline' : 'none');
        document.getElementById('td_bank_acct2').style.display = (this.dp1[0]['payment_type_key'] == 'bank' || this.dp1[0]['payment_type_key'] == 'visa' ? 'inline' : 'none');
      }
      this.model['is_paid'] = (this.dp1[0]['payment_type_key'] == 'credit' || this.dp1[0]['payment_type_key'] == 'tamara' || this.dp1[0]['payment_type_key'] == 'tabby' ? '0' : '1');
      this.dp1[0]['amount'] = this.data_model['final_total'];

      // ******************* change the flag to new if there is no id and update if there is  ******************* //
      for (index = 0; index < this.all_payment_types.length; index++) {
        if (this.all_payment_types[index]['payment_type_id'] == this.dp1[0]['payment_type_id']) {
          this.all_payment_types[index]['amount'] = this.dp1[0]['amount'];
          // console.log(this.dp1[0]['amount']);
          // this.all_payment_types[index]['flag'] = this.dp1[0]['flag'];

          if (this.all_payment_types[index]['inv_payment_method_id'] != '')
            this.all_payment_types[index]['flag'] = 'update';
          else
            this.all_payment_types[index]['flag'] = 'new';

          break;
        }
      }

      this.dataSource1 = new MatTableDataSource(this.dp1);
      this.dataSource1.sort = this.sort;
      if (this.dp1.length == 1)
        this.payment_method = (this.applicationConstants.user_lang == 'ar' ? this.dp1[0]['payment_type_name'] : this.dp1[0]['payment_type_name_en']);
      else
        this.payment_method = (this.applicationConstants.user_lang == 'ar' ? 'متعدد' : 'Multiple');
      // }
    }
    else {
      if (this.mode != undefined && this.mode == 'edit') {
        this.all_payment_types.forEach(element1 => {
          element1.amount = '';
          if (element1.inv_payment_method_id == '') {
            element1.flag = '';
          }
        });
      }
      else {
        this.all_payment_types.forEach(element1 => {
          element1.amount = '';
          element1.flag = '';
          element1.inv_payment_method_id = '';
        });
      }
      this.dp1 = [];
      this.dataSource1 = new MatTableDataSource(this.dp1);
      this.dataSource1.sort = this.sort;
      this.payment_method = '';
    }
    console.log(this.dp1);
    console.log(this.all_payment_types);
  }

  changePaid() {
    if (this.data_model['paid_amount'] != '')
      this.data_model['rem_amount'] = (Number(this.data_model['paid_amount']) - Number(this.data_model['final_total'])).toFixed(2);
    else
      this.data_model['rem_amount'] = '';
  }

  addPayment() {
    console.log(this.dp1);
    if (Number(this.data_model['final_total']) > 0) {
      let dialog_data = {
        'total_amount': this.data_model['final_total'], 'payment_methods': this.dp1,
        'all_payment_types': this.all_payment_types
      };
      this.payDialogRef = this.dialog.open(SuppInvPaymentMethodComponent, {
        hasBackdrop: false,
        data: dialog_data
      });
      this.payDialogRef
        .afterClosed()
        .subscribe(result => {
          if (result['payment_methods'] != undefined && Array.isArray(result['payment_methods'])) {
            let credit_existed = false;
            let bank_existed = false;

            result['payment_methods'].forEach(element => {
              if (element.payment_type_key == 'credit' ||element.payment_type_key == 'tamara' || element.payment_type_key == 'tabby')
                credit_existed = true;
              else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
                bank_existed = true;
            });
            document.getElementById('td_payment_date').style.display = (credit_existed ? 'inline' : 'none');
            document.getElementById('td_payment_date2').style.display = (credit_existed ? 'inline' : 'none');
            document.getElementById('td_bank_acct').style.display = (bank_existed ? 'inline' : 'none');
            document.getElementById('td_bank_acct2').style.display = (bank_existed ? 'inline' : 'none');
            this.model['is_paid'] = (credit_existed ? '0' : '1');

            this.dp1 = result['payment_methods'];
            this.dataSource1 = new MatTableDataSource(this.dp1);
            this.dataSource1.sort = this.sort;

            if (this.dp1.length == 1)
              this.payment_method = (this.applicationConstants.user_lang == 'ar' ? this.dp1[0]['payment_type_name'] : this.dp1[0]['payment_type_name_en']);
            else
              this.payment_method = (this.applicationConstants.user_lang == 'ar' ? 'متعدد' : 'Multiple');

            if (result['all_payment_types'] != undefined && Array.isArray(result['all_payment_types']))
              this.all_payment_types = result['all_payment_types'];
          }
        });
    }
    else
      alert(this.One_Item_Msg);
  }

  onChangeBankSearch = function (acct_number: string) {
    this.data_model['bank_acct_number'] = acct_number;
    console.log(this.data_model['bank_acct_number']);
    // ******************* In Edit Mode, change flag for bank or visa payment method to update if there is ******************* //
    if (this.mode != undefined && this.mode == 'edit') {

      this.dp1.forEach(element => {
        if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa') {

          this.all_payment_types.forEach(element1 => {
            if (element1.payment_type_key == element.payment_type_key) {
              if (element1.inv_payment_method_id != '')
                element1.flag = 'update';
              return false;
            }
          });

          return false;
        }
      });
    }
  }

  onChange = function (dpList: any) {
    this.dp = dpList['dp'];
    this.stock_list = dpList['stock_list']; 

    this.changeFinalTotal();
  }

  saveInvoice(save_type) {
    this.saveClicked = true;
    let invoice_item = [];

    let is_cash = false;
    let is_bank = false;
    this.dp1.forEach(element => {
      if (element.payment_type_key == 'cash')
        is_cash = true;
      else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
        is_bank = true;
    });

    //console.log('hi');
    if (Number(this.data_model['final_total']) == 0) {
      alert(this.One_Item_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['is_paid'] == '0' && this.model['customer_no'] == '') {
      alert(this.Customer_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['is_paid'] == '0' && this.data_model['is_cc'] == '0') {
      alert(this.Customer_Cc_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.dp1.length == 0) {
      alert(this.Pay_Msg);
      this.saveClicked = false;
      return;
    }

    if (is_bank && this.data_model['bank_acct_number'] == '0') {
      alert(this.Bank_Acct_Msg);
      this.saveClicked = false;
      return;
    }

    if (is_cash && this.applicationConstants.user_info['is_counter'] == '0') {
      alert(this.Not_Counter_Msg);
      this.saveClicked = false;
      return;
    }

    if ((this.type == '' || this.type == 'invoice') && this.model['is_paid'] == '0' && this.model['rep_emp_no'] == '0') {
      alert(this.Rep_Msg);
      this.saveClicked = false;
      return;
    }
   
    this.model['invoice_date'] = this.data_model['invoiceDate'].getFullYear() + "-" +
      (this.data_model['invoiceDate'].getMonth() + 1) + "-" + this.data_model['invoiceDate'].getDate() + ' ' +
      new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();

    if (this.dp1.length == 1) {
      if (this.dp1[0].payment_type_key == 'credit' || this.dp1[0].payment_type_key == 'tamara' || this.dp1[0].payment_type_key == 'tabby')
        this.model['acct_number'] = this.model['customer_no'];
      else if (this.dp1[0].payment_type_key == 'cash')
        this.model['acct_number'] = this.applicationConstants.user_info.casher_acct_number;
      else if (this.dp1[0].payment_type_key == 'bank' || this.dp1[0].payment_type_key == 'visa')
        this.model['acct_number'] = this.data_model['bank_acct_number'];

      this.model['payment_method'] = this.dp1[0].payment_type_key;
    }
    else {
      this.model['acct_number'] = '0';
      this.model['payment_method'] = '';
    }

    this.model['payment_date'] = (this.data_model['paymentDate'].getFullYear() + "-" +
      (this.data_model['paymentDate'].getMonth() + 1) + "-" + this.data_model['paymentDate'].getDate());

    // if (this.model['transport_fee'] != '0') this.model['trans_acct'] = this.applicationConstants.trans_acct;
    if (this.model['status'] != '1') {
      // this.model['status'] = '2';

      this.model['deliver_date'] = this.data_model['deliverDate'].getFullYear() + "-" +
        (this.data_model['deliverDate'].getMonth() + 1) + "-" + this.data_model['deliverDate'].getDate() + ' ' +
        new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();
    }
    else
      this.model['deliver_date'] = this.model['invoice_date'];

    if (this.menu_id == '12')
      this.model['invoice_type'] = 'maint';

    // the array that will be sent to the server 
    let values = [];

    if (this.model['flag'] != 'update') {
      this.model['branch_id'] = this.applicationConstants.user_branch_info.user_branch_id;
      this.model['store_id'] = this.applicationConstants.user_branch_info.user_store_id;
    }

    let first_tax_acct = this.dp['0']['tax_no'];
    let is_equal_tax = true;
    let year;
    
    if (this.type == '' || this.type == 'invoice') {

      if (this.mode != 'edit') {
        year = this.data_model['invoiceDate'].getFullYear();
        this.model['year'] = String(year);

        if (this.model['discount_perc'] == '')
          this.model['discount_perc'] = '0';

        if (this.model['retention_perc'] == '')
          this.model['retention_perc'] = '0';

        if (Number(this.model['retention_perc']) > 0)
          this.model['retention_amount'] = ((Number(this.model['retention_perc']) / 100) * Number(this.model['total'])).toFixed(2);

        let invoice_uuid = uuidv4();
        console.log('Your UUID is: ' + invoice_uuid);
        this.model['invoice_uuid'] = invoice_uuid;
      }

      let first_sales_acct = this.dp['0']['revenue_acct_no'];
      let is_equal_sales_acct = true;
  
      this.dp.forEach(element => {
        if (element.tax_no != first_tax_acct)
          is_equal_tax = false;
  
        if (element.revenue_acct_no != first_sales_acct)
          is_equal_sales_acct = false;
      });
  
      // TO DO HASSAN (6-17-20) changed temp because of workshop program [START]
      if (is_equal_tax)
        this.model['tax_acct'] = first_tax_acct; // this.applicationConstants.sales_acct.tax_acct; //
      if (is_equal_sales_acct)
        this.model['sales_acct'] = first_sales_acct; //this.applicationConstants.sales_acct.acct_number;//
      // [END]

      values.push(this.model); // invoice header
    }
    else if (this.type == "return_invoice") { // if it is return invoice

      if (this.mode != 'edit') {
        year = this.data_model['invoiceDate'].getFullYear();
        this.model['year'] = String(year);
      }
      this.model['ret_sales_acct'] = '0';

      let first_sales_ret_acct = this.dp['0']['sale_ret_acct_no'];
      let is_equal_sales_ret_acct = true;
  
      this.dp.forEach(element => {
        if (element.tax_no != first_tax_acct)
          is_equal_tax = false;
  
        if (element.sale_ret_acct_no != first_sales_ret_acct)
          is_equal_sales_ret_acct = false;
      });
  
      if (is_equal_tax)
        this.model['tax_acct'] = first_tax_acct; 
      if (is_equal_sales_ret_acct)
        this.model['ret_sales_acct'] = first_sales_ret_acct; 
  

      // return invoice header 
      values.push({
        'table_name': 'return_invoice', 'return_invoice_no': (this.mode == 'edit' ? this.no : '0'),
        'year': this.model['year'], 'no': '0', 'invoice_no': '', 
        'return_invoice_id': (this.mode == 'edit' ? this.invoice_detail['return_invoice_id'] : '0'),
        'customer_no': this.model['customer_no'], 'customer_name': this.model['customer_name'],
        'return_date': this.model['invoice_date'], 'total': this.model['total'],
        'discount': this.model['discount'], 'tax_acct': this.model['tax_acct'],
        'tax': this.model['tax'], 'ret_sales_acct': this.model['ret_sales_acct'],
        'flag': this.model['flag'], 'key': 'return_invoice_id', 'payment_method': this.model['payment_method'],
        'acct_number': this.model['acct_number'], 'is_paid': this.model['is_paid'], 'payment_voucher_no': '0',
        'status': '1', 'comment': '', 'branch_id': this.model['branch_id'], 'store_id': this.model['store_id']
      });
    }

    let sub_item_number, sub_item_name, count, price, unit_id, total_price, tax_no, tax_amount, discount,
      comment, available_stock, flag, key, invoice_item_id, inv_payment_method_id;
    let count_total, count_discount, count_tax, counter;

    // add invoice items
    this.dp.forEach(element => {
      if (element.sub_item_name == undefined) element.sub_item_name = '';
      if (element.sub_item_name_en == undefined) element.sub_item_name_en = '';

      // let warranty = '';
      // if (this.menu_id == '12') {
      //   if ((element.warranty_day != '' && element.warranty_day != '0') || (element.warranty_kilometer != '' && element.warranty_kilometer != '0')) {
      //     warranty = '- ضمان ' + element.warranty_day + ' يوم أو ' + element.warranty_kilometer + ' كيلومتر أيهما أقرب';
      //     console.log(warranty);
      //   }
      // }

      sub_item_number = element.sub_item_number;
      sub_item_name = element.sub_item_name;  // + " - " + element.sub_item_name_en;   // + warranty;
      total_price = element.total_price;

      if (sub_item_number != '' || (sub_item_name != '' && total_price != '')) {

        count = element.count;
        price = element.price;
        unit_id = element.unit_id;
        tax_no = element.tax_no;
        tax_amount = element.tax_amount;
        discount = element.discount;
        comment = element.comment;
        flag = element.flag;
        key = element.key;
        invoice_item_id = element.invoice_item_id;

        if (invoice_item_id == '' || invoice_item_id == null || invoice_item_id == undefined)
          invoice_item_id = '0';

        if (this.type == '' || this.type == 'invoice') { // invoice

          available_stock = this.stock_list[element.sub_item_no];
          counter = Number(count);

          if (this.model['invoice_type'] != 'install' && Number(element.available_count) >= counter && 
            available_stock.length > 0) {

            count_discount = 0;
            count_tax = 0;

            if (discount != '' && Number(discount) > 0)
              count_discount = Number(discount) / Number(count);

            if (tax_amount != '' && Number(tax_amount) > 0)
              count_tax = Number(tax_amount) / Number(count);

            available_stock.forEach(element1 => {

              if (Number(element1.available_count) > 0 && counter > 0) {

                if (Number(element1.available_count) >= counter) {
                  values.push({
                    'table_name': 'invoice_item', 'invoice_no': this.model['invoice_no'],
                    'invoice_date': this.model['invoice_date'],
                    'sub_item_number': (sub_item_number == '' ? '0' : sub_item_number),
                    'sub_item_name': sub_item_name, 'count': counter, 'price': price, 'unit_id': unit_id,
                    'total_price': (counter * price).toFixed(2), 'tax_no': tax_no,
                    'invoice_item_id': (this.mode == 'copy' ? '0' : invoice_item_id),
                    'tax_amount': (counter * count_tax).toFixed(2),
                    'flag': flag, 'key': key, 'discount': (counter * count_discount).toFixed(2),
                    'stock_no': element1.stock_no, 'store_id': element1.store_id,
                    'primary_sub_item_number': element1.primary_sub_item_number,
                    'primary_quantity': (Number(element1.primary_qty) * counter).toFixed(2),
                    'comment': comment, 'revenue_acct_no': element.revenue_acct_no
                  });

                  invoice_item.push({
                    'sub_item_name': sub_item_name, 'unit_name': element.unit_name,
                    'unit_name_en': element.unit_name_en, 'price': price, 'count': counter, 
                    'total_price': (counter * price).toFixed(2), 'tax_amount': (counter * count_tax).toFixed(2),
                    'discount': (counter * count_discount).toFixed(2),
                    'net_total_price': ((counter * price) - (counter * count_discount) + (counter * count_tax)).toFixed(2)
                  });

                  element1.available_count = (Number(element1.available_count) - counter);
                  counter = 0;
                }
                else {
                  values.push({
                    'table_name': 'invoice_item', 'invoice_no': this.model['invoice_no'],
                    'invoice_date': this.model['invoice_date'], 'invoice_item_id': (this.mode == 'copy' ? '0' : invoice_item_id),
                    'sub_item_number': (sub_item_number == '' ? '0' : sub_item_number),
                    'sub_item_name': sub_item_name, 'count': element1.available_count, 'price': price,
                    'unit_id': unit_id, 'total_price': (Number(element1.available_count) * price).toFixed(2),
                    'tax_no': tax_no, 'tax_amount': (Number(element1.available_count) * count_tax).toFixed(2),
                    'discount': (Number(element1.available_count) * count_discount).toFixed(2),
                    'stock_no': element1.stock_no, 'flag': flag, 'key': key,
                    'store_id': element1.store_id, 'primary_sub_item_number': element1.primary_sub_item_number,
                    'primary_quantity': (Number(element1.primary_qty) * Number(element1.available_count)).toFixed(2),
                    'comment': comment, 'revenue_acct_no': element.revenue_acct_no
                  });

                  invoice_item.push({
                    'sub_item_name': sub_item_name, 'unit_name': element.unit_name,
                    'unit_name_en': element.unit_name_en, 'price': price, 'count': element1.available_count,
                    'total_price': (element1.available_count * price).toFixed(2), 
                    'tax_amount': (element1.available_count * count_tax).toFixed(2), 
                    'discount': (element1.available_count * count_discount).toFixed(2), 
                    'net_total_price': ((element1.available_count * price) - (element1.available_count * count_discount) + (element1.available_count * count_tax)).toFixed(2)
                  });

                  counter -= Number(element1.available_count);
                  element1.available_count = 0;
                }
              }
            });

          }
          else {
            values.push({
              'table_name': 'invoice_item', 'invoice_no': this.model['invoice_no'],
              'invoice_date': this.model['invoice_date'], 'invoice_item_id': (this.mode == 'copy' ? '0' : invoice_item_id),
              'sub_item_number': (sub_item_number == '' ? '0' : sub_item_number), 'sub_item_name': sub_item_name,
              'flag': flag, 'key': key, 'count': count, 'price': price, 'unit_id': unit_id,
              'total_price': total_price, 'tax_no': tax_no, 'tax_amount': tax_amount, 
              'discount': discount, 'stock_no': '0', 'store_id': this.model['store_id'],
              'primary_sub_item_number': element.primary_sub_item_number, 
              'primary_quantity': (Number(element.primary_quantity) * count).toFixed(2),
              'comment': comment, 'revenue_acct_no': element.revenue_acct_no, 'install_perc': element.install_perc,
              'install_amount': element.install_amount, 'advanced_amount': element.advanced_amount
            });

            invoice_item.push({
              'sub_item_name': sub_item_name, 'unit_name': element.unit_name,
              'unit_name_en': element.unit_name_en, 'price': price, 'count': count, 
              'total_price': total_price, 'tax_amount': tax_amount, 'discount': discount, 
              'net_total_price': (Number(total_price) - Number(discount) + Number(tax_amount)).toFixed(2)
            });
          }
        }
        else if (this.type == "return_invoice") {
          values.push({
            'table_name': 'return_invoice_item', 'return_invoice_no': (this.mode == 'edit' ? this.no : '0'),
            'invoice_item_id': '0', 'return_item_id': (flag == 'update' ? element.return_item_id : '0'),
            'sub_item_number': (sub_item_number == '' ? '0' : sub_item_number), 'sub_item_name': sub_item_name,
            'return_count': count, 'price': price, 'unit_id': unit_id, 'flag': flag, 'key': 'return_item_id',
            'return_tax': tax_amount, 'total_price': total_price, 'discount': discount, 'tax_no': tax_no,
            'stock_no': '0', 'return_date': this.model['invoice_date'], 'store_id': this.model['store_id'],
            'sale_ret_acct_no': element.sale_ret_acct_no, 'primary_sub_item_number': element.primary_sub_item_number,
            'primary_quantity': (Number(element.primary_quantity) * Number(count)).toFixed(2),
            'comment': comment
          });
        }
      }
    });

    let acct_number;
    let has_credit_amount = false;
    this.all_payment_types.forEach(element1 => {
      if (element1.flag != '') {
        if (element1.payment_type_key == 'cash')
          acct_number = this.applicationConstants.user_info.casher_acct_number;
        else if (element1.payment_type_key == 'credit') {
          acct_number = this.model['customer_no'];
          has_credit_amount = true;
        }
        else if (element1.payment_type_key == 'bank' || element1.payment_type_key == 'visa')
          acct_number = this.data_model['bank_acct_number'];

        inv_payment_method_id = element1.inv_payment_method_id;
        if (inv_payment_method_id == '' || inv_payment_method_id == null || inv_payment_method_id == undefined ||
          inv_payment_method_id == 'undefined')
          inv_payment_method_id = '0';

        if (element1.amount == '')
          element1.amount = '0';

        if (this.type == '' || this.type == 'invoice') { // invoice
          values.push({
            'table_name': 'inv_payment_method', 'invoice_no': this.model['invoice_no'],
            'inv_payment_method_id': (this.mode == 'copy' ? '0' : inv_payment_method_id), 'flag': element1.flag, 'key': 'inv_payment_method_id',
            'payment_type_id': element1.payment_type_id, 'acct_number': acct_number, 'amount': element1.amount
          });
        }
        else if (this.type == "return_invoice") {
          values.push({
            'table_name': 'ret_inv_payment_method', 'return_invoice_no': (this.mode == 'edit' ? this.no : '0'),
            'flag': element1.flag, 'ret_inv_payment_method_id': (element1.inv_payment_method_id != '' && element1.inv_payment_method_id != undefined ? element1.inv_payment_method_id : '0'),
            'key': 'ret_inv_payment_method_id', 'payment_type_id': element1.payment_type_id,
            'acct_number': acct_number, 'amount': element1.amount
          });

        }
      }
    });

    console.log(values);
  
    if ((this.type == '' || this.type == 'invoice') && this.mode == 'edit') {
      this.toDelete.forEach(delElem => {
        values.push({
          'table_name': delElem['table_name'], 'invoice_item_id': delElem.invoice_item_id,
          'key': 'invoice_item_id', 'flag': 'delete', 'invoice_no': this.model['invoice_no']
        });
      });
    }
    else if (this.type == 'return_invoice' && this.mode == 'edit') {
      this.toDelete.forEach(delElem => {
        values.push({
          'table_name': delElem['table_name'], 'return_item_id': delElem.return_item_id,
          'key': 'return_item_id', 'flag': 'delete', 'return_invoice_no': this.no
        });
      });
    }
    
    let obj, prefix;
    if (this.type == '' || this.type == 'invoice') {

      if (this.mode == 'edit')
        obj = { cmd: 'updateAdv', values: values };
      else {
        
        let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
          this.applicationConstants.user_branch_info.user_branch_id + "'";
        prefix = this.applicationConstants.user_branch_info.user_branch_id + '-' + year + '-';

        obj = {
          cmd: 'add', values: values, pk: 'invoice_no', id: 'no', main_table: 'invoice',
          prefix: prefix, idWhere: idWhere
        };
      }
    }
    else {
      if (this.type == "return_invoice") {
        
        if (this.mode == 'edit')
          obj = { cmd: 'updateAdv', values: values };
        else {
          
          let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
            this.applicationConstants.user_branch_info.user_branch_id + "'";
          prefix = 'RET-' + this.applicationConstants.user_branch_info.user_branch_id + "-" + year;

          obj = {
            cmd: 'add', values: values, pk: 'return_invoice_no', id: 'no', main_table: 'return_invoice',
            prefix: prefix, idWhere: idWhere
          };
        }
      }
    }

    console.log(values);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          let invoice_no = '';

          if (this.mode == 'edit') 
            invoice_no = this.no;
          else 
            invoice_no = data.status['msg'][0]['number'];

          if (this.type == '' || this.type == 'invoice') {
            
            if (has_credit_amount || this.data_model['has_cash_receipt'] == 1) {
              obj = {
                cmd: 'updateCashReceipt', invoice_no: invoice_no,
                user_name: this.applicationConstants.user_info['user_name']
              };

              this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.status['type'] == 'error')
                    alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);
                  
                  alert(this.Success_Msg + this.Inv_No_Msg + invoice_no);
                });
            }
            else
              alert(this.Success_Msg + this.Inv_No_Msg + invoice_no);
          }
          else 
            alert(this.Success_Msg + this.Inv_No_Msg + invoice_no);


          // if (this.mode == 'edit') {
          //   invoice_no = this.no;

          //   // check if total has changed and there is cash receipt for this invoice, then fix the remaining
          //   if (this.data_model['has_cash_receipt'] == 1 && this.data_model['old_final_total'] != (Number(this.data_model['final_total']) + Number(this.model['transport_fee']))) {

          //     obj = {
          //       cmd: 'updateCashReceipt', invoice_no: invoice_no,
          //       user_name: this.applicationConstants.user_info['user_name']
          //     };

          //     this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
          //       .subscribe(data => {
          //         this.applicationConstants.appComp.hideBusyCursor();

          //         if (data.status['type'] == 'error')
          //           alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);
          //         else
          //           alert(this.Success_Msg + this.Inv_No_Msg + invoice_no);

          //       });
          //   }
          //   else
          //     alert(this.Success_Msg + this.Inv_No_Msg + invoice_no);
          // }
          // else {
          //   invoice_no = data.status['msg'][0]['number'];
          //   alert(this.Success_Msg + this.Inv_No_Msg + invoice_no);
          // }

          if (save_type == 'print') {
            if (this.print_type == 'normal') {
              if (this.type == '' || this.type == 'invoice') {
                if (this.menu_id == '1')
                  window.open(this.applicationConstants.generateInvoice + "?no=" + invoice_no, "_blank");
                // window.open(this.applicationConstants.generatePDF + "?type=invoice&no=" + invoice_no, "_blank");
                else if (this.menu_id == '12')
                  window.open(this.applicationConstants.generateInvoice + "?maint=true&no=" + invoice_no, "_blank");

                this.router.navigate(['sub_menu/1/invoice_list']);
              }
              else if (this.type == "return_invoice") {
                window.open(this.applicationConstants.generatePDF + "?type=" + this.type + "&no=" + invoice_no, "_blank");
                this.router.navigate(['sub_menu/1/return_invoice_list']);
              }
            }
            else if (this.print_type == 'thermal') {
              if (this.type == '' || this.type == 'invoice') {
                
                if (this.thermal_print_type == 'pdf')
                  window.open(this.applicationConstants.generateThermalInvoice + "?no=" + invoice_no, "_blank");
                else {
                  let printObj = {
                    cmd: 'printThermal', type: 'invoice', no: invoice_no,
                    params: this.applicationConstants.param, invoice_info: this.model, 
                    invoice_item: invoice_item, created_by: this.applicationConstants.user_info['name'],
                    user_id: this.applicationConstants.user_info['user_id']
                  };
                  console.log(printObj);
                  this.utils.invokeHttp(this.applicationConstants.saleFuncFile, printObj)
                    .subscribe(data => {
                      this.applicationConstants.appComp.hideBusyCursor();
                    });
                }

                // this.router.navigate(['sub_menu/1/invoice_list']);
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                  this.router.navigate(['sub_menu/1/invoice']); // navigate to same route
                });
              }
              else if (this.type == "return_invoice")
                this.router.navigate(['sub_menu/1/return_invoice_list']);
            }
          }
          else {
            if (this.type == '' || this.type == 'invoice')
              this.router.navigate(['sub_menu/1/invoice_list']);
            else
              this.router.navigate(['sub_menu/1/return_invoice_list']);
          }
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });
  }

  discount(event) {
    if (isNaN(Number(event.srcElement.value))) {
      this.data_model['inv_discount'] = String(parseFloat(event.srcElement.value));
      (document.getElementById('inv_discount') as HTMLInputElement).value = this.data_model['inv_discount'];
    }

    if (isNaN(Number(event.srcElement.value))) {
      this.data_model['inv_discount'] = '0';
      (document.getElementById('inv_discount') as HTMLInputElement).value = '0';
    }

    if (!isNaN(Number(event.srcElement.value))) {
      let final_discount = (Number(this.data_model['item_discount']) + Number(this.data_model['inv_discount'])).toFixed(2);
      let total = Number(this.model['total']);
      let final_total = total - Number(final_discount);
      this.model['tax'] = (Number(final_total) * (5 / 100)).toFixed(2);
      this.data_model['final_total'] = (Number(final_total) + Number(this.model['tax']) + 
        Number(this.model['transport_fee'])).toFixed(2);
      this.model['discount'] = final_discount;
      this.data_model['final_discount'] = final_discount;
      (document.getElementById('final_total') as HTMLInputElement).value = this.data_model['final_total'];
      this.changeFinalTotal();
    }
  }

  transport_fee() {
    
    let dialog_data = [{ transport_fee: this.model['transport_fee'], 
      trans_acct: this.model['trans_acct'] }, 
      { transAcctList: this.transAcctList, transDetail: this.transDetail }];

    this.feeDialogRef = this.dialog.open(TransportFeeComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.feeDialogRef
      .afterClosed()
      .subscribe(result => {
        this.model['transport_fee'] = result['transport_fee'];
        this.model['trans_acct'] = result['trans_acct'];

        // calculate the final total
        this.data_model['final_total'] = (Number(this.model['total']) -
                  Number(this.model['discount']) + Number(this.model['tax']) + 
                  Number(this.model['transport_fee'])).toFixed(2);

        (document.getElementById('final_total') as HTMLInputElement).value = this.data_model['final_total'];
        this.changeFinalTotal();
      });
  }

  new_or_cancel() {

    this.router.navigateByUrl('sub_menu/1', { skipLocationChange: true }).then(() =>
      this.router.navigate(["sub_menu/1/invoice"]));
  }

}
